export const defaultTimeInputWithSecondsValidator = (value: string, prevValue: string): string => {
  // Блокировка недопустимых символов
  if (/[a-zA-Zа-яА-ЯйЙ]/g.test(value)) return prevValue;

  // Очистка от всего кроме цифр и двоеточий
  const cleaned = value.replace(/[^\d:]/g, '');

  // Если ввод начинается с двоеточия
  if (cleaned[0] === ':') return '00:';

  // Форматирование цифр в time format
  let result = '';
  let digitCount = 0;

  for (let i = 0; i < cleaned.length; i++) {
    const char = cleaned[i];

    if (char === ':') {
      // Проверяем условия для добавления двоеточия
      const hasDoubleColon = result.includes('::');
      const endsWithColon = result.endsWith(':') && result.length > 0;
      const colonCount = (result.match(/:/g) || []).length;

      if (!hasDoubleColon && !endsWithColon && colonCount < 2) {
        result += ':';
        digitCount = 0;
      }
    } else if (digitCount < 2) {
      result += char;
      digitCount += 1;

      // Автоматически добавляем двоеточие после 2 цифр
      const colonCount = (result.match(/:/g) || []).length;
      if (digitCount === 2 && i < cleaned.length - 1 && colonCount < 2) {
        result += ':';
        digitCount = 0;
      }
    }

    // Прерываем если достигли максимума
    if (result.length >= 8) break;
  }

  return result;
};

export const parseTimeString = (
  timeString: string
): {
  milliseconds: number;
  isValid: boolean;
  formatted: string;
} => {
  if (!timeString || typeof timeString !== 'string') {
    return { milliseconds: 0, isValid: false, formatted: '00:00:00' };
  }

  const parts = timeString.split(':');
  const result = {
    hours: 0,
    minutes: 0,
    seconds: 0,
    isValid: true,
  };

  if (parts.length >= 1) {
    result.hours = parseInt(parts[0], 10);
    if (Number.isNaN(result.hours) || result.hours < 0) {
      result.isValid = false;
    }
  }

  if (parts.length >= 2 && result.isValid) {
    result.minutes = parseInt(parts[1], 10);
    if (Number.isNaN(result.minutes) || result.minutes < 0 || result.minutes > 59) {
      result.isValid = false;
    }
  }

  if (parts.length >= 3 && result.isValid) {
    result.seconds = parseInt(parts[2], 10);
    if (Number.isNaN(result.seconds) || result.seconds < 0 || result.seconds > 59) {
      result.isValid = false;
    }
  }

  const milliseconds = result.hours * 3600000 + result.minutes * 60000 + result.seconds * 1000;

  const formatPart = (num: number): string => Math.max(0, num).toString().padStart(2, '0');

  const formatted = `${formatPart(result.hours)}.${formatPart(result.minutes)}.${formatPart(result.seconds)}`;
  return {
    milliseconds: result.isValid ? milliseconds : 0,
    isValid: result.isValid,
    formatted,
  };
};

export const formatMillisecondsToTime = (ms?: number | null): string => {
  if (!ms) return '';

  if (ms < 0 || Number.isNaN(ms)) return '00:00:00';

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const formatPart = (num: number): string => num.toString().padStart(2, '0');

  return `${formatPart(hours)}:${formatPart(minutes)}:${formatPart(seconds)}`;
};
